import WorkActivities from "views/pages/WorkActivities";

export const premedReqs = [
    "Class not a Premed Requirement",
    "Biology 1",
    "Biology 2",
    "Biology Lab 1",
    "Biology Lab 2",
    "Chemistry 1",
    "Chemistry 2",
    "Chemistry Lab 1",
    "Chemistry Lab 2",
    "Physics 1",
    "Physics 2",
    "Physics Lab 1",
    "Physics Lab 2",
    "Organic Chemistry 1",
    "Organic Chemistry 2",
    "Organic Chemistry Lab 1",
    "English 1",
    "English 2",
    "Social Science 1",
    "Social Science 2",
    "Calculus",
    "Statistics 1",
    "Biochemistry 1",
    "Upper Level Science 1",
    "Upper Level Science 2",
    "Other Premed Requirement"

];


export const testMcatScore = [
    { value: "Official MCAT Score", label: "Official MCAT Score" , color: '#5e72e4' },
    { value: "AAMC MCAT Official Prep Practice Exam One", label: "AAMC MCAT Official Prep Practice Exam One" , color: '#8898aa' },
    { value: "AAMC MCAT Official Prep Practice Exam Two", label: "AAMC MCAT Official Prep Practice Exam Two" , color: '#8898aa' },
    { value: "AAMC MCAT Official Prep Practice Exam Three", label: "AAMC MCAT Official Prep Practice Exam Three" , color: '#8898aa' },
    { value: "AAMC MCAT Official Prep Practice Exam Four", label: "AAMC MCAT Official Prep Practice Exam Four" , color: '#8898aa' },
    { value: "MCAT Official Prep Free Practice Exam (Scored)", label: "MCAT Official Prep Free Practice Exam (Scored)" , color: '#8898aa' },
    { value: "MCAT Official Prep Free Practice Exam (Unscored)", label: "MCAT Official Prep Free Practice Exam (Unscored)" , color: '#8898aa' },
    { value: "Other", label: "Other" , color: '#8898aa' }
];


// export const schoolYear = [
//     { "value": "highschool", "label": "Highschool" },
//     { "value": "freshman", "label": "Freshman" },
//     { "value": "sophomore", "label": "Sophomore" },
//     { "value": "junior", "label": "Junior" },
//     { "value": "senior", "label": "Senior" },
//     { "value": "postbac", "label": "Postbac" },
//     { "value": "masters", "label": "Masters" }
// ]

export const schoolYear = [
    // { "value": "highschool", "label": "Highschool" },
    { "value": "freshman", "label": "Freshman" },
    { "value": "sophomore", "label": "Sophomore" },
    { "value": "junior", "label": "Junior" },
    { "value": "senior", "label": "Senior" },
    { "value": "postbac", "label": "Postbac" },
    { "value": "graduate", "label": "Graduate" }
]


export const secondaryEssayStatus = [
    { value: "pre-submission", label: "pre-submission" , color: '#5e72e4' },
    { value: "working on secondary", label: "working on secondary", color: '#ffd600' },
    { value: "submitted", label: "submitted", color: '#2dce89' },
    { value: "pending interview", label: "pending interview", color: '#fb6340' },
    { value: "interview received", label: "interview received", color: '#5603ad' },
    { value: "interview scheduled", label: "interview scheduled", color: '#11cdef' },
    { value: "interview completed", label: "interview completed" , color: '#8965e0'},
    { value: "waitlisted", label: "waitlisted", color: '#8898aa' },
    { value: "rejected", label: "rejected", color: '#f5365c' },
    { value: "accepted", label: "accepted" , color: '#11cdef'}
];




export const optionCountries = [
{ value : "US",label:"United States"},
{ value : "AF",label:"Afghanistan"},
{ value : "AX",label:"Åland Islands"},
{ value : "AL",label:"Albania"},
{ value : "DZ",label:"Algeria"},
{ value : "AS",label:"American Samoa"},
{ value : "AD",label:"Andorra"},
{ value : "AO",label:"Angola"},
{ value : "AI",label:"Anguilla"},
{ value : "AQ",label:"Antarctica"},
{ value : "AG",label:"Antigua and Barbuda"},
{ value : "AR",label:"Argentina"},
{ value : "AM",label:"Armenia"},
{ value : "AW",label:"Aruba"},
{ value : "AU",label:"Australia"},
{ value : "AT",label:"Austria"},
{ value : "AZ",label:"Azerbaijan"},
{ value : "BS",label:"Bahamas"},
{ value : "BH",label:"Bahrain"},
{ value : "BD",label:"Bangladesh"},
{ value : "BB",label:"Barbados"},
{ value : "BY",label:"Belarus"},
{ value : "BE",label:"Belgium"},
{ value : "BZ",label:"Belize"},
{ value : "BJ",label:"Benin"},
{ value : "BM",label:"Bermuda"},
{ value : "BT",label:"Bhutan"},
{ value : "BO",label:"Bolivia"},
{ value : "BQ",label:"Bonaire, Sint Eustatius and Saba"},
{ value : "BA",label:"Bosnia and Herzegovina"},
{ value : "BW",label:"Botswana"},
{ value : "BV",label:"Bouvet Island"},
{ value : "BR",label:"Brazil"},
{ value : "IO",label:"British Indian Ocean Territory"},
{ value : "BN",label:"Brunei Darussalam"},
{ value : "BG",label:"Bulgaria"},
{ value : "BF",label:"Burkina Faso"},
{ value : "BI",label:"Burundi"},
{ value : "KH",label:"Cambodia"},
{ value : "CM",label:"Cameroon"},
{ value : "CA",label:"Canada"},
{ value : "CV",label:"Cape Verde"},
{ value : "KY",label:"Cayman Islands"},
{ value : "CF",label:"Central African Republic"},
{ value : "TD",label:"Chad"},
{ value : "CL",label:"Chile"},
{ value : "CN",label:"China"},
{ value : "CX",label:"Christmas Island"},
{ value : "CC",label:"Cocos (Keeling) Islands"},
{ value : "CO",label:"Colombia"},
{ value : "KM",label:"Comoros"},
{ value : "CG",label:"Congo, Republic of the (Brazzaville)"},
{ value : "CD",label:"Congo, the Democratic Republic of the (Kinshasa)"},
{ value : "CK",label:"Cook Islands"},
{ value : "CR",label:"Costa Rica"},
{ value : "CI",label:"Côte d'Ivoire, Republic of"},
{ value : "HR",label:"Croatia"},
{ value : "CU",label:"Cuba"},
{ value : "CW",label:"Curaçao"},
{ value : "CY",label:"Cyprus"},
{ value : "CZ",label:"Czech Republic"},
{ value : "DK",label:"Denmark"},
{ value : "DJ",label:"Djibouti"},
{ value : "DM",label:"Dominica"},
{ value : "DO",label:"Dominican Republic"},
{ value : "EC",label:"Ecuador"},
{ value : "EG",label:"Egypt"},
{ value : "SV",label:"El Salvador"},
{ value : "GQ",label:"Equatorial Guinea"},
{ value : "ER",label:"Eritrea"},
{ value : "EE",label:"Estonia"},
{ value : "ET",label:"Ethiopia"},
{ value : "FK",label:"Falkland Islands (Islas Malvinas)"},
{ value : "FO",label:"Faroe Islands"},
{ value : "FJ",label:"Fiji"},
{ value : "FI",label:"Finland"},
{ value : "FR",label:"France"},
{ value : "GF",label:"French Guiana"},
{ value : "PF",label:"French Polynesia"},
{ value : "TF",label:"French Southern and Antarctic Lands"},
{ value : "GA",label:"Gabon"},
{ value : "GM",label:"Gambia, The"},
{ value : "GE",label:"Georgia"},
{ value : "DE",label:"Germany"},
{ value : "GH",label:"Ghana"},
{ value : "GI",label:"Gibraltar"},
{ value : "GR",label:"Greece"},
{ value : "GL",label:"Greenland"},
{ value : "GD",label:"Grenada"},
{ value : "GP",label:"Guadeloupe"},
{ value : "GU",label:"Guam"},
{ value : "GT",label:"Guatemala"},
{ value : "GG",label:"Guernsey"},
{ value : "GN",label:"Guinea"},
{ value : "GW",label:"Guinea-Bissau"},
{ value : "GY",label:"Guyana"},
{ value : "HT",label:"Haiti"},
{ value : "HM",label:"Heard Island and McDonald Islands"},
{ value : "VA",label:"Holy See (Vatican City)"},
{ value : "HN",label:"Honduras"},
{ value : "HK",label:"Hong Kong"},
{ value : "HU",label:"Hungary"},
{ value : "IS",label:"Iceland"},
{ value : "IN",label:"India"},
{ value : "ID",label:"Indonesia"},
{ value : "IR",label:"Iran, Islamic Republic of"},
{ value : "IQ",label:"Iraq"},
{ value : "IE",label:"Ireland"},
{ value : "IM",label:"Isle of Man"},
{ value : "IL",label:"Israel"},
{ value : "IT",label:"Italy"},
{ value : "JM",label:"Jamaica"},
{ value : "JP",label:"Japan"},
{ value : "JE",label:"Jersey"},
{ value : "JO",label:"Jordan"},
{ value : "KZ",label:"Kazakhstan"},
{ value : "KE",label:"Kenya"},
{ value : "KI",label:"Kiribati"},
{ value : "KP",label:"Korea, Democratic People's Republic of"},
{ value : "KR",label:"Korea, Republic of"},
{ value : "XK",label:"Kosovo"},
{ value : "KW",label:"Kuwait"},
{ value : "KG",label:"Kyrgyzstan"},
{ value : "LA",label:"Laos"},
{ value : "LV",label:"Latvia"},
{ value : "LB",label:"Lebanon"},
{ value : "LS",label:"Lesotho"},
{ value : "LR",label:"Liberia"},
{ value : "LY",label:"Libya"},
{ value : "LI",label:"Liechtenstein"},
{ value : "LT",label:"Lithuania"},
{ value : "LU",label:"Luxembourg"},
{ value : "MO",label:"Macao"},
{ value : "MK",label:"Macedonia, Republic of"},
{ value : "MG",label:"Madagascar"},
{ value : "MW",label:"Malawi"},
{ value : "MY",label:"Malaysia"},
{ value : "MV",label:"Maldives"},
{ value : "ML",label:"Mali"},
{ value : "MT",label:"Malta"},
{ value : "MH",label:"Marshall Islands"},
{ value : "MQ",label:"Martinique"},
{ value : "MR",label:"Mauritania"},
{ value : "MU",label:"Mauritius"},
{ value : "YT",label:"Mayotte"},
{ value : "MX",label:"Mexico"},
{ value : "FM",label:"Micronesia, Federated States of"},
{ value : "MD",label:"Moldova"},
{ value : "MC",label:"Monaco"},
{ value : "MN",label:"Mongolia"},
{ value : "ME",label:"Montenegro"},
{ value : "MS",label:"Montserrat"},
{ value : "MA",label:"Morocco"},
{ value : "MZ",label:"Mozambique"},
{ value : "MM",label:"Myanmar"},
{ value : "NA",label:"Namibia"},
{ value : "NR",label:"Nauru"},
{ value : "NP",label:"Nepal"},
{ value : "NL",label:"Netherlands"},
{ value : "NC",label:"New Caledonia"},
{ value : "NZ",label:"New Zealand"},
{ value : "NI",label:"Nicaragua"},
{ value : "NE",label:"Niger"},
{ value : "NG",label:"Nigeria"},
{ value : "NU",label:"Niue"},
{ value : "NF",label:"Norfolk Island"},
{ value : "MP",label:"Northern Mariana Islands"},
{ value : "NO",label:"Norway"},
{ value : "OM",label:"Oman"},
{ value : "PK",label:"Pakistan"},
{ value : "PW",label:"Palau"},
{ value : "PS",label:"Palestine, State of"},
{ value : "PA",label:"Panama"},
{ value : "PG",label:"Papua New Guinea"},
{ value : "PY",label:"Paraguay"},
{ value : "PE",label:"Peru"},
{ value : "PH",label:"Philippines"},
{ value : "PN",label:"Pitcairn"},
{ value : "PL",label:"Poland"},
{ value : "PT",label:"Portugal"},
{ value : "PR",label:"Puerto Rico"},
{ value : "QA",label:"Qatar"},
{ value : "RE",label:"Réunion"},
{ value : "RO",label:"Romania"},
{ value : "RU",label:"Russian Federation"},
{ value : "RW",label:"Rwanda"},
{ value : "BL",label:"Saint Barthélemy"},
{ value : "SH",label:"Saint Helena, Ascension and Tristan da Cunha"},
{ value : "KN",label:"Saint Kitts and Nevis"},
{ value : "LC",label:"Saint Lucia"},
{ value : "MF",label:"Saint Martin"},
{ value : "PM",label:"Saint Pierre and Miquelon"},
{ value : "VC",label:"Saint Vincent and the Grenadines"},
{ value : "WS",label:"Samoa"},
{ value : "SM",label:"San Marino"},
{ value : "ST",label:"Sao Tome and Principe"},
{ value : "SA",label:"Saudi Arabia"},
{ value : "SN",label:"Senegal"},
{ value : "RS",label:"Serbia"},
{ value : "SC",label:"Seychelles"},
{ value : "SL",label:"Sierra Leone"},
{ value : "SG",label:"Singapore"},
{ value : "SX",label:"Sint Maarten (Dutch part)"},
{ value : "SK",label:"Slovakia"},
{ value : "SI",label:"Slovenia"},
{ value : "SB",label:"Solomon Islands"},
{ value : "SO",label:"Somalia"},
{ value : "ZA",label:"South Africa"},
{ value : "GS",label:"South Georgia and South Sandwich Islands"},
{ value : "SS",label:"South Sudan"},
{ value : "ES",label:"Spain"},
{ value : "LK",label:"Sri Lanka"},
{ value : "SD",label:"Sudan"},
{ value : "SR",label:"Suriname"},
{ value : "SZ",label:"Eswatini"},
{ value : "SE",label:"Sweden"},
{ value : "CH",label:"Switzerland"},
{ value : "SY",label:"Syrian Arab Republic"},
{ value : "TW",label:"Taiwan"},
{ value : "TJ",label:"Tajikistan"},
{ value : "TZ",label:"Tanzania, United Republic of"},
{ value : "TH",label:"Thailand"},
{ value : "TL",label:"Timor-Leste"},
{ value : "TG",label:"Togo"},
{ value : "TK",label:"Tokelau"},
{ value : "TO",label:"Tonga"},
{ value : "TT",label:"Trinidad and Tobago"},
{ value : "TN",label:"Tunisia"},
{ value : "TR",label:"Turkey"},
{ value : "TM",label:"Turkmenistan"},
{ value : "TC",label:"Turks and Caicos Islands"},
{ value : "TV",label:"Tuvalu"},
{ value : "UG",label:"Uganda"},
{ value : "UA",label:"Ukraine"},
{ value : "AE",label:"United Arab Emirates"},
{ value : "GB",label:"United Kingdom"},
{ value : "UM",label:"United States Minor Outlying Islands"},
{ value : "UY",label:"Uruguay"},
{ value : "UZ",label:"Uzbekistan"},
{ value : "VU",label:"Vanuatu"},
{ value : "VE",label:"Venezuela, Bolivarian Republic of"},
{ value : "VN",label:"Vietnam"},
{ value : "VG",label:"Virgin Islands, British"},
{ value : "VI",label:"Virgin Islands, U.S."},
{ value : "WF",label:"Wallis and Futuna"},
{ value : "EH",label:"Western Sahara"},
{ value : "YE",label:"Yemen"},
{ value : "ZM",label:"Zambia"},
{ value : "ZW",label:"Zimbabwe"}]



export const terms = [
    { value: "Fall", label: "Fall" },
    { value: "Spring", label: "Spring" },
    { value: "Winter", label: "Winter" },
    { value: "Summer", label: "Summer" }
]

export const grades = [
    { value: "A+", label: "A+" },
    { value: "A", label: "A" },
    { value: "A-", label: "A-" },
    { value: "AB", label: "AB" },
    { value: "B+", label: "B+" },
    { value: "B", label: "B" },
    { value: "B-", label: "B-" },
    { value: "BC", label: "BC" },
    { value: "C+", label: "C+" },
    { value: "C", label: "C" },
    { value: "C-", label: "C-" },
    { value: "CD", label: "CD" },
    { value: "D+", label: "D+" },
    { value: "D", label: "D" },
    { value: "D-", label: "D-" },
    { value: "DE", label: "DE" },
    { value: "F", label: "F" },
    { value: "Pass", label: "Pass" },
    { value: "Fail", label: "Fail" },
    { value: "Transfer", label: "Transfer" },
    { value: "Withdraw", label: "Withdraw" }
]


export const schoolYears = [
    { value: "freshman", label: "Freshman" },
    { value: "sophomore", label: "Sophomore" },
    { value: "junior", label: "Junior" },
    { value: "senior", label: "Senior" },
    { value: "postbac", label: "Postbac" },
    { value: "graduate", label: "Graduate" }
]


export const experienceType = [
    { value: "Artistic Endeavors", label: "Artistic Endeavors" },
    { value: "Community Service/Volunteer - Medical/Clinical", label: "Community Service/Volunteer - Medical/Clinical" },
    { value: "Community Service/Volunteer - Not Medical/Clinical", label: "Community Service/Volunteer - Not Medical/Clinical" },
    { value: "Conferences Attended", label: "Conferences Attended" },
    { value: "Extracurricular Activities", label: "Extracurricular Activities" },
    { value: "Hobbies", label: "Hobbies" },
    { value: "Honors/Awards/Recognitions", label: "Honors/Awards/Recognitions" },
    { value: "Intercollegiate Athletics", label: "Intercollegiate Athletics" },
    { value: "Leadership - Not Listed Elsewhere", label: "Leadership - Not Listed Elsewhere" },
    { value: "Military Service", label: "Military Service" },
    { value: "Paid Employment - Medical/Clinical", label: "Paid Employment - Medical/Clinical" },
    { value: "Paid Employment - Not Medical/Clinical", label: "Paid Employment - Not Medical/Clinical" },
    { value: "Physician Shadowing/Clinical Observation", label: "Physician Shadowing/Clinical Observation" },
    { value: "Presentations/Posters", label: "Presentations/Posters" },
    { value: "Publications", label: "Publications" },
    { value: "Research/La", label: "Research/Lab" },
    { value: "Teaching/Tutoring/Teaching Assistant", label: "Teaching/Tutoring/Teaching Assistant" },
    { value: "Social Justice/Advocacy", label: "Social Justice/Advocacy" },
    { value: "Other", label: "Other" }
  ]


export const workActivitiesType = [
    { value: "Activity", label: "Activity" },
    { value: "Clinical", label: "Clinical" },
    { value: "Shadowing", label: "Shadowing" },
    { value: "Volunteering", label: "Volunteering" }
]


export const monthsList = [
    { "value": "1", "label": "January" },
    { "value": "2", "label": "February" },
    { "value": "3", "label": "March" },
    { "value": "4", "label": "April" },
    { "value": "5", "label": "May" },
    { "value": "6", "label": "June" },
    { "value": "7", "label": "July" },
    { "value": "8", "label": "August" },
    { "value": "9", "label": "September" },
    { "value": "10", "label": "October" },
    { "value": "11", "label": "November" },
    { "value": "12", "label": "December" }
  ]



export const yearsList = () => {
    const year = new Date().getFullYear();
	const yearsArray = Array.from(new Array(100), (v, i) => ({
		value: year - i,
		label: String(year - i), // Convert the value to a string to be used as the label
	}));

	return yearsArray;
}

export const yearsListObject = (yearStarted) => {
    // const year = new Date().getFullYear();
    
	// const yearsArray = Array.from((new Array(100)).filter(num => num >= yearStarted), (v, i) => ({
	// 	value: year - i,
	// 	label: String(year - i), // Convert the value to a string to be used as the label
	// }));

    const year = new Date().getFullYear(); // Replace with the current year or desired starting point
    // const yearStarted = 1925; // Replace with the desired starting year

    const yearsArray = Array.from(
    { length: year - yearStarted + 1 }, // Create a range from yearStarted to year
    (_, i) => {
        const value = year - i;
        return {
        value: value,
        label: String(value), // Convert the value to a string for the label
        };
    }
    );


	return yearsArray;
}

export const studentsLifetimePlan = [
    "manalibrahim456@gmail.com",
    "yassin.issa08@gmail.com",
    "chidoziedeclan@gmail.com",
    "mayasarkis2018@gmail.com",
    "sarah.rahmoun12@icloud.com",
    "atassir2001@gmail.com",
    "maryamsiddiqui13@yahoo.com",
    "tueminhmary2105@gmail.com",
    "alaskanfiremedic@gmail.com",
    "dmendez23@ucmerced.edu",
    "ktorabzadeh02@icloud.com",
    "jessicaannlobb@gmail.com",
    "senevm1@unlv.nevada.edu",
    "tahirajaved600@gmail.com",
    "nithyashankar.03@gmail.com",
    "nrobertson081@gmail.com",
    "karlee.waugh10@gmail.com",
    "kgomez4208@berkeley.edu",
    "tzanouangeliki@gmail.com",
    "jhajjmahek@gmail.com",
    "jerrymend04@gmail.com",
    "nurkoandrea3@gmail.com",
    "thompsonlydia38@gmail.com",
    "kennyweng8@gmail.com",
    "gianellamv721@hotmail.com",
    "nicolemanelis1@gmail.com",
    "tuazonpred@gmail.com",
    "adn34@cornell.edu",	

    // "ringor71@gmail.com",
    "faizsiddiqui2024@gmail.com",
    "ashishfranklin@hotmail.com",
    "lynamora27@gmail.com"

    
    
]

export const pmrProgramOptions = [
    { value: 'University of Alabama Medical Center PM&R Program', label: 'University of Alabama Medical Center PM&R Program' },
    { value: 'University of Arkansas for Medical Sciences PM&R Program', label: 'University of Arkansas for Medical Sciences PM&R Program' },
    { value: 'HonorHealth PM&R Program', label: 'HonorHealth PM&R Program' },
    { value: 'Charles R. Drew University of Medicine and Science', label: 'Charles R. Drew University of Medicine and Science' },
    { value: 'Loma Linda University Health Education Consortium PM&R Program', label: 'Loma Linda University Health Education Consortium PM&R Program' },
    { value: 'VA Greater Los Angeles Healthcare System (UCLA) PM&R Program', label: 'VA Greater Los Angeles Healthcare System (UCLA) PM&R Program' },
    { value: 'University of California (Irvine) PM&R Program', label: 'University of California (Irvine) PM&R Program' },
    { value: 'OPTI West (Casa Colina) PM&R Program', label: 'OPTI West (Casa Colina) PM&R Program' },
    { value: 'Stanford University PM&R Program', label: 'Stanford University PM&R Program' },
    { value: 'University of California (Davis) Health PM&R Program', label: 'University of California (Davis) Health PM&R Program' },
    { value: 'University of Colorado PM&R Program', label: 'University of Colorado PM&R Program' },
    { value: 'UConn Health/Hartford Hospital/Gaylord Specialty Healthcare', label: 'UConn Health/Hartford Hospital/Gaylord Specialty Healthcare' },
    { value: 'Yale - New Haven', label: 'Yale - New Haven' },
    { value: 'Medstar Health/Georgetown-National Rehabilitation Hospital PM&R Program', label: 'Medstar Health/Georgetown-National Rehabilitation Hospital PM&R Program' },
    { value: 'Broward Health Program', label: 'Broward Health Program' },
    { value: 'HCA Florida Healthcare/USF Morsani College of Medicine', label: 'HCA Florida Healthcare/USF Morsani College of Medicine' },
    { value: 'Mayo Clinic Florida', label: 'Mayo Clinic Florida' },
    { value: 'University of Florida College of Medicine PM&R Program', label: 'University of Florida College of Medicine PM&R Program' },
    { value: 'Memorial Healthcare System (Hollywood) PM&R Program', label: 'Memorial Healthcare System (Hollywood) PM&R Program' },
    { value: 'University of Miami/Jackson Health System PM&R Program', label: 'University of Miami/Jackson Health System PM&R Program' },
    { value: 'University of Central Florida/HCA Healthcare GME (Pensacola) PM&R Program', label: 'University of Central Florida/HCA Healthcare GME (Pensacola) PM&R Program' },
    { value: 'University of Central Florida/HCA Healthcare (Sanford)', label: 'University of Central Florida/HCA Healthcare (Sanford)' },
    { value: 'Larkin Community Hospital PM&R Program (South Miami)', label: 'Larkin Community Hospital PM&R Program (South Miami)' },
    { value: 'Larkin Community Hospital (Palm Springs)', label: 'Larkin Community Hospital (Palm Springs)' },
    { value: 'University of South Florida Morsani (James A Haley Veterans Hosp) PM&R Program', label: 'University of South Florida Morsani (James A Haley Veterans Hosp) PM&R Program' },
    { value: 'Emory University School of Medicine PM&R Program', label: 'Emory University School of Medicine PM&R Program' },
    { value: 'McGaw Medical Center of Northwestern University (SRAL) PM&R Program', label: 'McGaw Medical Center of Northwestern University (SRAL) PM&R Program' },
    { value: 'Rush University Medical Center PM&R Program', label: 'Rush University Medical Center PM&R Program' },
    { value: 'Schwab Rehabilitation Hospital & Care Network/University of Chicago PM&R Program', label: 'Schwab Rehabilitation Hospital & Care Network/University of Chicago PM&R Program' },
    { value: 'Marianjoy Rehabilitation Hospital PM&R Program', label: 'Marianjoy Rehabilitation Hospital PM&R Program' },
    { value: 'Indiana University School of Medicine PM&R Program', label: 'Indiana University School of Medicine PM&R Program' },
    { value: 'Parkview Health', label: 'Parkview Health' },
    { value: 'University of Kansas School of Medicine PM&R Program', label: 'University of Kansas School of Medicine PM&R Program' },
    { value: 'University of Kentucky College of Medicine PM&R Program', label: 'University of Kentucky College of Medicine PM&R Program' },
    { value: 'University of Louisville School of Medicine PM&R Program', label: 'University of Louisville School of Medicine PM&R Program' },
    { value: 'Louisiana State University PM&R Program', label: 'Louisiana State University PM&R Program' },
    { value: 'Tufts Medical Center PM&R Program', label: 'Tufts Medical Center PM&R Program' },
    { value: 'Spaulding Rehabilitation Hospital/Harvard Medical School PM&R Program', label: 'Spaulding Rehabilitation Hospital/Harvard Medical School PM&R Program' },
    { value: 'Sinai Hospital of Baltimore PM&R Program', label: 'Sinai Hospital of Baltimore PM&R Program' },
    { value: 'Johns Hopkins University PM&R Program', label: 'Johns Hopkins University PM&R Program' },
    { value: 'National Capital Consortium PM&R Program', label: 'National Capital Consortium PM&R Program' },
    { value: 'University of Michigan PM&R Program', label: 'University of Michigan PM&R Program' },
    { value: 'Detroit Medical Center/Wayne State University PM&R Program', label: 'Detroit Medical Center/Wayne State University PM&R Program' },
    { value: 'Mary Free Bed Hospital PM&R Program', label: 'Mary Free Bed Hospital PM&R Program' },
    { value: 'Sparrow Hospital (Michigan State University) PM&R Program', label: 'Sparrow Hospital (Michigan State University) PM&R Program' },
    { value: 'Beaumont Health (Royal Oak) PM&R Program', label: 'Beaumont Health (Royal Oak) PM&R Program' },
    { value: 'Beaumont Health (Taylor) PM&R Program', label: 'Beaumont Health (Taylor) PM&R Program' },
    { value: 'University of Minnesota PM&R Program', label: 'University of Minnesota PM&R Program' },
    { value: 'Mayo Clinic College of Medicine and Science (Rochester) PM&R Program', label: 'Mayo Clinic College of Medicine and Science (Rochester) PM&R Program' },
    { value: 'University of Missouri-Columbia PM&R Program', label: 'University of Missouri-Columbia PM&R Program' },
    { value: 'Washington University/B-JH/SLCH Consortium PM&R Program', label: 'Washington University/B-JH/SLCH Consortium PM&R Program' },
    { value: 'University of North Carolina Hospitals PM&R Program', label: 'University of North Carolina Hospitals PM&R Program' },
    { value: 'Carolinas Medical Center PM&R Program', label: 'Carolinas Medical Center PM&R Program' },
    { value: 'Vidant Medical Center/East Carolina University PM&R Program', label: 'Vidant Medical Center/East Carolina University PM&R Program' },
    { value: 'University of Nebraska Medical Center College of Medicine PM&R Program', label: 'University of Nebraska Medical Center College of Medicine PM&R Program' },
    { value: 'JFK Medical Center PM&R Program', label: 'JFK Medical Center PM&R Program' },
    { value: 'Inspira Health Network PM&R Program', label: 'Inspira Health Network PM&R Program' },
    { value: 'Rutgers New Jersey Medical School PM&R Program', label: 'Rutgers New Jersey Medical School PM&R Program' },
    { value: 'University of New Mexico School of Medicine PM&R Program', label: 'University of New Mexico School of Medicine PM&R Program' },
    { value: 'Sunrise Health GME Consortium PM&R Program', label: 'Sunrise Health GME Consortium PM&R Program' },
    { value: 'Albany Medical Center PM&R Program', label: 'Albany Medical Center PM&R Program' },
    { value: 'Montefiore Medical Center/Albert Einstein College of Medicine PM&R Program', label: 'Montefiore Medical Center/Albert Einstein College of Medicine PM&R Program' },
    { value: 'One Brooklyn Health System/Kingsbrook Jewish Medical Center PM&R Program', label: 'One Brooklyn Health System/Kingsbrook Jewish Medical Center PM&R Program' },
    { value: 'State University of New York (SUNY) Downstate Health Sciences University PM&R Program', label: 'State University of New York (SUNY) Downstate Health Sciences University PM&R Program' },
    { value: 'Nassau University Medical Center PM&R Program', label: 'Nassau University Medical Center PM&R Program' },
    { value: 'Zucker School of Medicine at Hofstra/Northwell PM&R', label: 'Zucker School of Medicine at Hofstra/Northwell PM&R' },
    { value: 'New York Presbyterian Hospital (Columbia and Cornell) PM&R Program', label: 'New York Presbyterian Hospital (Columbia and Cornell) PM&R Program' },
    { value: 'Icahn School of Medicine At Mount Sinai PM&R Program', label: 'Icahn School of Medicine At Mount Sinai PM&R Program' },
    { value: 'New York Medical College (Metropolitan) PM&R Program', label: 'New York Medical College (Metropolitan) PM&R Program' },
    { value: 'New York University School of Medicine PM&R Program', label: 'New York University School of Medicine PM&R Program' },
    { value: 'Stony Brook Medicine PM&R Program', label: 'Stony Brook Medicine PM&R Program' },
    { value: 'Rochester Regional Health/Unity Hospital PM&R Program', label: 'Rochester Regional Health/Unity Hospital PM&R Program' },
    { value: 'University of Rochester PM&R Program', label: 'University of Rochester PM&R Program' },
    { value: 'Good Samaritan Hospital Medical Center PM&R Program', label: 'Good Samaritan Hospital Medical Center PM&R Program' },
    { value: 'State University of New York (SUNY) Upstate Medical University PM&R Program', label: 'State University of New York (SUNY) Upstate Medical University PM&R Program' },
    { value: 'Westchester Medical Center', label: 'Westchester Medical Center' },
    { value: 'Burke Rehabilitation Hospital PM&R Program', label: 'Burke Rehabilitation Hospital PM&R Program' },
    { value: 'University of Cincinnati Medical Center/College of Medicine PM&R Program', label: 'University of Cincinnati Medical Center/College of Medicine PM&R Program' },
    { value: 'Cleveland Clinic Foundation PM&R Program', label: 'Cleveland Clinic Foundation PM&R Program' },
    { value: 'Case Western Reserve University (MetroHealth) PM&R Program', label: 'Case Western Reserve University (MetroHealth) PM&R Program' },
    { value: 'Ohio State University Hospital PM&R Program', label: 'Ohio State University Hospital PM&R Program' },
    { value: 'University Hospitals Osteopathic Consortium (UHOC) PM&R Program', label: 'University Hospitals Osteopathic Consortium (UHOC) PM&R Program' },
    { value: 'University of Toledo PM&R Program', label: 'University of Toledo PM&R Program' },
    { value: 'Geisinger Health System PM&R Program', label: 'Geisinger Health System PM&R Program' },
    { value: 'Penn State Milton S Hershey Medical Center PM&R Program', label: 'Penn State Milton S Hershey Medical Center PM&R Program' },
    { value: 'Albert Einstein Healthcare Network/MossRehab PM&R Program', label: 'Albert Einstein Healthcare Network/MossRehab PM&R Program' },
    { value: 'University of Pennsylvania PM&R Program', label: 'University of Pennsylvania PM&R Program' },
    { value: 'Temple University Hospital/Moss Rehabilitation PM&R Program', label: 'Temple University Hospital/Moss Rehabilitation PM&R Program' },
    { value: 'Sidney Kimmel Medical College At Thomas Jefferson University/TJUH PM&R', label: 'Sidney Kimmel Medical College At Thomas Jefferson University/TJUH PM&R' },
    { value: 'UPMC Medical Education PM&R Program', label: 'UPMC Medical Education PM&R Program' },
    { value: 'Wright Center for Graduate Medical Education Program', label: 'Wright Center for Graduate Medical Education Program' },
    { value: 'Tower Health PM&R Program', label: 'Tower Health PM&R Program' },
    { value: 'VA Caribbean Healthcare System PM&R Program', label: 'VA Caribbean Healthcare System PM&R Program' },
    { value: 'University of Puerto Rico PM&R Program', label: 'University of Puerto Rico PM&R Program' },
    { value: 'Medical University of South Carolina', label: 'Medical University of South Carolina' },
    { value: 'HCA Healthcare/Mercer University School of Medicine/Trident Medical Center Program', label: 'HCA Healthcare/Mercer University School of Medicine/Trident Medical Center Program' },
    { value: 'HCA Healthcare/TriStar Nashville', label: 'HCA Healthcare/TriStar Nashville' },
    { value: 'Vanderbilt University Medical Center PM&R Program', label: 'Vanderbilt University Medical Center PM&R Program' },
    { value: 'University of Texas At Austin Dell Medical School PM&R Program', label: 'University of Texas At Austin Dell Medical School PM&R Program' },
    { value: 'Baylor University Medical Center PM&R Program', label: 'Baylor University Medical Center PM&R Program' },
    { value: 'University of Texas Southwestern Medical School PM&R Program', label: 'University of Texas Southwestern Medical School PM&R Program' },
    { value: 'Baylor College of Medicine PM&R Program', label: 'Baylor College of Medicine PM&R Program' },
    { value: 'Texas Rehabilitation Hospital of Fort Worth PM&R Program', label: 'Texas Rehabilitation Hospital of Fort Worth PM&R Program' },
    { value: 'University of Texas Health Science Center At Houston PM&R Program', label: 'University of Texas Health Science Center At Houston PM&R Program' },
    { value: 'Texas Tech University HSC', label: 'Texas Tech University HSC' },
    { value: 'University of Texas Health Science Center SOM At San Antonio PM&R Program', label: 'University of Texas Health Science Center SOM At San Antonio PM&R Program' },
    { value: 'University of Utah PM&R Program', label: 'University of Utah PM&R Program' },
    { value: 'University of Virginia Medical Center PM&R Program', label: 'University of Virginia Medical Center PM&R Program' },
    { value: 'Old Dominion University Program', label: 'Old Dominion University Program' },
    { value: 'Virginia Commonwealth University Health System PM&R Program', label: 'Virginia Commonwealth University Health System PM&R Program' },
    { value: 'University of Washington PM&R Program', label: 'University of Washington PM&R Program' },
    { value: 'Providence Sacred Heart Medical Center PM&R Program', label: 'Providence Sacred Heart Medical Center PM&R Program' },
    { value: 'West Virginia University School of Medicine', label: 'West Virginia University School of Medicine' },
    { value: 'University of Wisconsin Hospitals and Clinics PM&R Program', label: 'University of Wisconsin Hospitals and Clinics PM&R Program' },
    { value: 'Medical College of Wisconsin Affiliated Hospitals PM&R Program', label: 'Medical College of Wisconsin Affiliated Hospitals PM&R Program' },
];

export const avatarColors = [
    "bg-gradient-blue",
    "bg-gradient-indigo",
    "bg-gradient-purple",
    "bg-gradient-pink",
    "bg-gradient-red",
    "bg-gradient-teal",
    "bg-gradient-cyan",
    "bg-gradient-primary",
    "bg-gradient-info",
    "bg-gradient-danger",
];